import React from 'react';
import ReactDOM from 'react-dom';
export default function RenderOnPortal(props) {
    var containerElement = React.useRef(document.createElement('div'));
    var rootElement = React.useState(function () {
        if (props.root) {
            return props.root;
        }
        var root = document.createElement('div');
        document.body.appendChild(root);
        return root;
    })[0];
    React.useEffect(function () {
        var root = rootElement;
        root.appendChild(containerElement.current);
        return function () {
            root.removeChild(containerElement.current);
        };
    }, []);
    return ReactDOM.createPortal(props.children, containerElement.current);
}
